export default "__VITE_ASSET__BB5ENoma__"